import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormRatingField, {
  IMxFormRatingFieldProps
} from "@rf-l2/form/rating/MxFormRatingField";

interface MxFormL3RatingFieldProps extends IMxFormRatingFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}

const MxFormL3RatingField = (props: MxFormL3RatingFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormRatingField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3RatingField;
